export default "__VITE_ASSET__DSFIQ8HE__"